import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './ButtonLink.module.css';
import useAccessibility from 'hooks/useAccessibility';

const ButtonLink = ({ link= '', variant = 'primary', title = '', ariaLabel = '', target, label= '' }) => {
    const accessibilityVariant = useAccessibility();

    return (
        <Link
            to={link}
            className={`${styles.buttonLink} ${styles[variant]} ${styles[accessibilityVariant]}`}
            title={title}
            aria-label={ariaLabel}
            target={target}
        >
            {label}
        </Link>
    );
};

ButtonLink.propTypes = {
    link: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'white', 'neutral, map']),  // Style du bouton
    title: PropTypes.string,              // Titre du bouton
    ariaLabel: PropTypes.string,          // Label ARIA pour l'accessibilité
    target: PropTypes.string
};

export default ButtonLink;
